import customerApi from '../../components/apis/customerApi';

export function getGuestTicketBookingForm(params) {
  return customerApi.get('/api/ticket-search', { params }).then((res) => res.data);
}

export function searchTicket(values, abortSignal) {
  return customerApi.post('/api/ticket-search', values, {
    signal: abortSignal,
  }).then((res) => res.data);
}

export function searchCustomerStatementRides(values, abortSignal) {
  return customerApi.post('/api/ticket-search/customer-statements', values, {
    signal: abortSignal,
  }).then((res) => res.data);
}

export function checkSearch(values) {
  return customerApi.post('/api/ticket-search/check', values).then((res) => res.data);
}

export function getChosenPassengers() {
  return customerApi.get('/api/chosen-passengers').then((res) => res.data);
}

export function reserveSeatsWithServices(values) {
  return customerApi.post('/api/ticket-booking/reserve-seats', values).then((res) => res.data);
}

export function purchaseSeats(id, statementGuid, data) {
  return customerApi.post(`/api/ticket-purchase/${id}/${statementGuid}`, data).then((res) => res.data);
}

export function getTrainsInfo(params) {
  return customerApi.get('/api/ticket-booking/seats', { params }).then((res) => res.data);
}

export function createDefaultBooking(values) {
  return customerApi.post('/api/ticket-booking/default', values).then((res) => res.data);
}

export function reserveRideSeat(values) {
  return customerApi.post('/api/ticket-booking/reserve-seat', values).then((res) => res.data);
}

export function cancelReserveRideSeat(values) {
  return customerApi.post('/api/ticket-booking/cancel-seat-reserve', values).then((res) => res.data);
}

export function getStatementById(id, guid) {
  return customerApi.get(`/api/ticket-booking/statement/${id}/${guid}`).then((res) => res.data);
}

export function uploadBookingVatFile(values) {
  return customerApi.post('/api/ticket-booking/vat-file', values).then((res) => res.data);
}

export function createCustomerStatement(values) {
  return customerApi.post('/api/ticket-booking/create-statement-booking', values).then((res) => res.data);
}

export function getRideAdditionalServices(id, params) {
  return customerApi.get(`/api/ticket-search/ride-services/${id}`, { params }).then((res) => res.data);
}

export function changeBookedStatementPaymentVolume(values) {
  return customerApi.put('/api/ticket-purchase/booked-statement/payment-volume', values).then((res) => res.data);
}

export function generateInvoiceBookingService(id, guid) {
  return customerApi.post(`/api/ticket-booking/generate-invoice-booking/${id}/${guid}`).then((res) => res.data);
}

export function approveReserve(values) {
  return customerApi.post('/api/ticket-booking/approve', values).then((res) => res.data);
}

export async function cancelStatement(id, guid) {
  return customerApi.post('/api/ticket-booking/cancel-statement', {
    id,
    guid,
  }).then((res) => res.data);
}
